import React, { useEffect, useState } from 'react';

import styled from '@emotion/styled';

import BreadCrumbs from '../../../components/BreadCrumbs/BreadCrumbs';
import PageLayout from '../../../components/Layout/PageLayout';
import Page from '../../../components/Page/Page';
import {
  REVENUE,
  REVENUE_PRICE_MANAGEMENT,
} from '../../../routes/routeConstants';
import ManagePriceForm from './ManagePriceForm';

const RevenuePriceManagement = () => {
  const [pathArr, setPathArr] = useState<Record<string, string>[]>([]);

  useEffect(() => {
    setPathArr(() => [
      {
        name: `Revenue`,
        link: `/${REVENUE}`,
      },
      {
        name: `Set Price`,
        link: `/${REVENUE_PRICE_MANAGEMENT}`,
      },
    ]);
    // eslint-disable-next-line
  }, []);

  return (
    <Page title='Logirate | Revenue Price Management'>
      <PageLayout noTitle>
        <BreadCrumbs pathData={pathArr as any} />

        <Container>
          <HeaderArea>
            <Header>Pricing Management</Header>
            <HeaderDescription>
              Configure lookup prices and bundles
            </HeaderDescription>
          </HeaderArea>

          <ManagePriceForm />
        </Container>
      </PageLayout>
    </Page>
  );
};

export default RevenuePriceManagement;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 28px;
`;

const HeaderArea = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

const Header = styled.div`
  font-weight: 600;
  font-size: 22px;
  line-height: 22px;
  color: #232222;
`;

const HeaderDescription = styled.div`
  font-size: 14px;
  line-height: 14px;
  line-height: 14px;
  color: #6b7280;
`;
